import { jsx as _jsx } from "react/jsx-runtime";
import React, { useState } from "react";
export const TransferPaymentsContext = React.createContext(undefined);
export const TransferPaymentsContextProvider = (props) => {
    const [formState, updateFormsState] = useState({});
    const initialStage = "Create";
    const [formStage, updateFormsStage] = useState(initialStage);
    const [fundsTransferId, updateFundsTransferId] = useState(undefined);
    const [fromAccount, updateFromAccount] = useState(undefined);
    const [toAccount, updateToAccount] = useState(undefined);
    const [transferType, updateTransferType] = useState(props.transferType);
    const [isPending, updateIsPending] = useState(undefined);
    const context = {
        formStage: formStage,
        formState: formState,
        transferType: transferType,
        fundsTransferId: fundsTransferId,
        fromAccount: fromAccount,
        toAccount: toAccount,
        isPending: isPending,
        updateform: (formState) => updateFormsState(() => formState),
        updateStage: (formStage) => updateFormsStage(() => formStage),
        updateFundsTransfer: updateFundsTransferId,
        updateFromAccount: (fromAccount) => updateFromAccount(() => fromAccount),
        updateToAccount: (toAccount) => updateToAccount(() => toAccount),
        updateTransferType: (transferType) => updateTransferType(() => transferType),
        updateIsPending: updateIsPending,
    };
    return (_jsx(TransferPaymentsContext.Provider, { value: context, children: props.children }));
};
